export const TUTORIAL_STEPS = [
  {
    id: 'categories-overview',
    title: 'LeetCode Categories',
    description:
      'Questions are organized by topic. Start with Arrays & Hashing and work your way down to more complicated topics!',
    placement: 'bottom',
    image: '/maincar.png',
    action: null,
  },
  {
    id: 'first-category',
    title: 'Arrays & Hashing',
    description:
      "Click 'next' to expand the Arrays & Hashing category. This is a great place to start your LeetCode journey!",
    placement: 'right',
    image: '/thinkingcar.png',
    action: 'click',
  },
  {
    id: 'first-question',
    title: 'Question Details',
    description:
      'Each question shows its difficulty, your progress status, and has a direct link to LeetCode.',
    placement: 'right',
    image: '/maincar.png',
    action: null,
  },
  {
    id: 'mock-interview',
    title: 'Mock Interview',
    description:
      'Practice with our AI interviewer! Click "Start Interview" to begin a mock interview session.',
    placement: 'left',
    image: '/writingcar.png',
    action: 'click',
  },
];
